import { useEffect, useRef } from "react"
import ReactDOM from "react-dom"

const Modal = ({ children }) => {
  // Use useRef to create a persistent DOM element for this component instance
  const elRef = useRef(document.createElement("div"))
  const el = elRef.current

  // Find the modal root each time the component renders.
  // This is safe and ensures we get the latest reference.
  const modalRoot = document.getElementById("modal-root")

  useEffect(() => {
    if (modalRoot) {
      modalRoot.appendChild(el)
    } else {
      console.warn("Modal root element with id 'modal-root' not found.")
      return 
    }

    return () => {
      if (modalRoot.contains(el)) {
        modalRoot.removeChild(el)
      }
    }
  }, [el, modalRoot])

  if (!modalRoot) {
    return null
  }

  return ReactDOM.createPortal(children, el)
}

export default Modal
